import * as r from 'ramda';
import { call, takeLeading } from 'redux-saga/effects';

import * as actions from '../actions';
import { updateArtset } from '../helpers/updateArtset';
import { fetchSingleArtset } from '../helpers/fetchSingleArtset';
import { createArtProductServerConfiguration } from '../helpers/createArtProductServerConfiguration';

const updateArtProduct = function* (artProduct) {
  const artProductServer = createArtProductServerConfiguration(artProduct);

  const artsetToUpdate = yield call(fetchSingleArtset);

  const findProductByID = r.pathEq(['Configuration', 'Id'], artProduct.id);
  const artsetProductIndexToReplace = r.findIndex(findProductByID)(artsetToUpdate.Products);
  artsetToUpdate.Products[artsetProductIndexToReplace] = artProductServer;
  yield call(updateArtset, artsetToUpdate);
};

const submitArtProductUpdate = function* ({ payload }) {
  const { artProduct } = payload;
  yield call(updateArtProduct, artProduct);

  const { callbacks } = payload;
  callbacks.onSuccess();
};

export const updateArtProductSaga = function* () {
  yield takeLeading(actions.submitArtProductUpdate, submitArtProductUpdate);
};
